function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M11.912 18.536H5.07c-2.523 0-4.569-2.049-4.569-4.575V5.108C.501 2.581 2.547.533 5.07.533h6.842c2.523 0 4.569 2.048 4.569 4.575v8.853c0 2.526-2.046 4.575-4.569 4.575zm3.071-13.428c0-1.696-1.378-3.075-3.071-3.075H5.07C3.377 2.033 2 3.412 2 5.108v8.853c0 1.695 1.377 3.075 3.07 3.075h6.842c1.693 0 3.071-1.38 3.071-3.075V5.108zm-3.466 8.929H5.466c-.407 0-.736-.33-.736-.736 0-.407.329-.737.736-.737h6.051c.406 0 .735.33.735.737 0 .406-.329.736-.735.736zm0-3.766H5.466c-.407 0-.736-.33-.736-.737 0-.406.329-.736.736-.736h6.051c.406 0 .735.33.735.736 0 .407-.329.737-.735.737zM7.756 6.504h-2.29c-.407 0-.736-.329-.736-.736s.329-.736.736-.736h2.29c.406 0 .735.329.735.736s-.329.736-.735.736z"
});

var SvgTradingAccounts = function SvgTradingAccounts(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 19,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTradingAccounts, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/trading_accounts.c4798ef3.svg";
export { ForwardRef as ReactComponent };